import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-loaderr',
  templateUrl: './loaderr.component.html',
  styleUrls: ['./loaderr.component.scss']
})
export class LoaderrComponent implements OnInit {
  isLoading: any;
  constructor(private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.loaderService.isLoading.subscribe(res => {
      this.isLoading = res
    });

  }
}
